<template>
  <div class="main-box">
    <el-form class="form-inline" size="small" :inline="true">
      <el-form-item label="">
        <el-select v-model="search.user_type" placeholder="请选择会员类型" clearable>
          <el-option v-for="item in userTypeList" :key="item.id" :label="item.title" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="search.grade_id" placeholder="请选择会员身份" clearable>
          <el-option v-for="item in gradeList" :key="item.id" :label="item.title" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-input v-model="search.keywords" placeholder="请输入姓名/手机号" size="small" clearable>
          <el-button slot="append" class="iv-search" size="small" type="primary" @click="handleSearch">搜索</el-button>
        </el-input>
      </el-form-item>
    </el-form>
    <el-table
        :data="tableData"
        ref="rfTable"
        style="width: 100%"
        size="mini"
        @selection-change="handleSelectionChange">
      <el-table-column
          prop="user_id"
          label="会员ID">
      </el-table-column>
      <el-table-column
          prop="name"
          label="昵称"
          align="center">
      </el-table-column>
      <el-table-column
          prop="avatar"
          label="头像"
          align="center">
        <template slot-scope="scope">
          <el-avatar :size="40" shape="square" :src="scope.row.avatar"></el-avatar>
        </template>
      </el-table-column>
      <el-table-column
          prop="mobile"
          label="手机号"
          align="center"
          width="120">
      </el-table-column>
<!--      <el-table-column-->
<!--              prop="tweeter_up"-->
<!--              label="上上级"-->
<!--              align="left"-->
<!--              width="200">-->
<!--        <template slot-scope="scope">-->
<!--          <div v-if="scope.row.tweeter_up" style="display: flex; align-items: center">-->
<!--            <el-avatar :size="40" shape="square" :src="scope.row.tweeter_up.avatar" class="mg-rt-10"></el-avatar>-->
<!--            <div>{{scope.row.tweeter_up.name}}<br>{{scope.row.tweeter_up.user_id}}</div>-->
<!--          </div>-->
<!--          <div v-else>-</div>-->
<!--        </template>-->
<!--      </el-table-column>-->
      <el-table-column
          prop="user_type"
          label="会员类型"
          align="left"
          width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.user_type == 1">普通用户</span>
          <span v-else-if="scope.row.user_type == 2">门店会员</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="grade_name"
          label="会员身份"
          align="left"
          width="120">
        <template slot-scope="scope">
          {{scope.row.grade_name || '-'}}
        </template>
      </el-table-column>
      <el-table-column
          prop="integral"
          label="积分"
          align="left"
          width="120">
        <template slot-scope="scope">
          {{scope.row.integral}} <el-button type="text" size="small" @click="lookIntegralList(scope.row.id)">查看</el-button>
        </template>
      </el-table-column>
<!--      <el-table-column-->
<!--          prop="balance"-->
<!--          label="余额"-->
<!--          align="center">-->
<!--        <template slot-scope="scope">-->
<!--          ￥{{scope.row.balance}} <el-button type="text" size="small" @click="lookBalanceList(scope.row.id)">查看</el-button>-->
<!--        </template>-->
<!--      </el-table-column>-->
      <el-table-column
          prop="commission"
          label="业绩"
          align="left">
        <template slot-scope="scope">
          ￥{{scope.row.commission}} <el-button type="text" size="small" @click="lookCommissionList(scope.row.id)">查看</el-button>
        </template>
      </el-table-column>
      <el-table-column
          prop="tweeter"
          label="上级"
          align="left"
          width="200">
        <template slot-scope="scope">
          <div v-if="scope.row.tweeter" style="display: flex; align-items: center">
            <el-avatar :size="40" shape="square" :src="scope.row.tweeter.avatar" class="mg-rt-10"></el-avatar>
            <div>{{scope.row.tweeter.name}}<br>{{scope.row.tweeter.user_id}}</div>
          </div>
          <div v-else>-</div>
        </template>
      </el-table-column>
      <el-table-column
          prop="status"
          label="登录状态"
          align="center"
          width="100">
        <template slot-scope="scope">
          <el-switch :value="scope.row.status==1" @change="changeStatus(scope.row.id,scope.row.status==1?0:1)">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
          prop="create_time"
          label="注册时间"
          align="center"
          width="140">
      </el-table-column>
      <el-table-column
          fixed="right"
          label="操作"
          align="center"
          width="180">
        <template slot-scope="scope">
          <div v-if="scope.row.user_type == 2">
            <el-button type="text" size="small" @click="showJfBox(scope.row)">变更积分</el-button>
<!--            <el-button type="text" size="small" @click="showCommissionBox(scope.row)">变更业绩</el-button>-->
          </div>
          <div v-if="scope.row.user_type == 2">
            <el-button type="text" size="small" @click="showPBox(scope.row)">变更上级</el-button>
            <el-button type="text" size="small" class="mg-lf-10" @click="showVipBox(scope.row)">设置会员</el-button>
          </div>
          <div v-else>-</div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        background
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 30, 40]"
        :total="search.total">
    </el-pagination>
    <el-dialog
        title="修改积分"
        :visible.sync="showJfDialog"
        :destroy-on-close="true"
        :close-on-click-modal="false"
        width="500px">
      <el-form :model="jfInfo" label-position="right" ref="ruleForm" label-width="60px" class="ruleForm" size="small">
        <el-form-item label="类型" prop="type">
          <el-radio-group v-model="jfInfo.type">
            <el-radio :label="item.id" v-for="(item,index) in integralTypeList" :key="index" :value="item.id">{{item.title}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="积分" prop="sum">
          <el-input v-model="jfInfo.sum" placeholder="请输入积分"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="jfInfo.remark" placeholder="请输入备注"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveIntegral">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
        title="修改余额"
        :visible.sync="showDialog"
        :destroy-on-close="true"
        :close-on-click-modal="false"
        width="500px">
      <el-form :model="moneyInfo" label-position="right" ref="ruleForm" label-width="100px" class="ruleForm" size="small">
        <el-form-item label="类型" prop="type">
          <el-radio-group v-model="moneyInfo.type">
            <el-radio :label="1">增加</el-radio>
            <el-radio :label="2">减少</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="余额" prop="sum">
          <el-input v-model="moneyInfo.sum" placeholder="请输入金额"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="moneyInfo.remark" placeholder="请输入备注"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveMoney">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
        title="修改业绩"
        :visible.sync="showCommissionDialog"
        :destroy-on-close="true"
        :close-on-click-modal="false"
        width="500px">
      <el-form :model="commissionInfo" label-position="right" ref="ruleForm" label-width="100px" class="ruleForm" size="small">
        <el-form-item label="类型" prop="type">
          <el-radio-group v-model="commissionInfo.type">
            <el-radio :label="item.id" v-for="(item,index) in commissionTypeList" :key="index" :value="item.id">{{item.title}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="业绩" prop="sum">
          <el-input v-model="commissionInfo.sum" placeholder="请输入金额"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="commissionInfo.remark" placeholder="请输入备注"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveCommission">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
        title="变更上级"
        :visible.sync="showPDialog"
        :destroy-on-close="true"
        :close-on-click-modal="false"
        width="500px">
      <el-form :model="commissionInfo" label-position="right" ref="ruleForm" label-width="60px" class="ruleForm" size="small">
        <el-form-item label="选择上级" prop="member">
          <span class="font12 mg-rt-10" v-if="parentInfo.member">{{parentInfo.member.name}} {{parentInfo.member.user_id}}</span>
          <el-button type="primary" @click="showMemberDialog = true">选择</el-button>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="parentInfo.remark" placeholder="请输入备注"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="changeParentOk()">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
        title="选择会员"
        :visible.sync="showMemberDialog"
        :destroy-on-close="true"
        :close-on-click-modal="false"
        width="70%">
      <member-list :type="1" :selectFunc="chooseMember"></member-list>
    </el-dialog>
    <el-dialog
        title="设置会员类型"
        :visible.sync="showVipDialog"
        :destroy-on-close="true"
        :close-on-click-modal="false"
        width="500px">
      <el-form :model="vipMember" label-position="left" ref="ruleForm" label-width="100px" class="ruleForm" size="small">
        <el-form-item label="请选择" prop="grade_id">
          <el-select v-model="vipMember.grade_id" placeholder="请选择会员类型">
            <el-option
                v-for="item in gradeList"
                :key="item.id"
                :label="item.title"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="vipMember.remark" placeholder="请输入备注"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="setGradeOk()">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>

import MemberList from "@/components/MemberList";
import commission from "@/view/member/commission.vue";
export default {
  components: {
    MemberList
  },
  data() {
    return {
      gradeList: [],
      userTypeList: [
          {id: 1, title: '普通用户'},
          {id: 2, title: '门店会员'}
      ],
      integralTypeList: [
        {id: 1, title: '门店充值'},
        {id: 5, title: '门店退款(不变动会员身份)'},
      ],
      commissionTypeList: [
        {id: 3, title: '增加业绩'},
        {id: 4, title: '扣除业绩'},
      ],
      jfInfo: {
        id: 0,
        type: '',
        sum: '',
        remark: ''
      },
      moneyInfo: {
        id: 0,
        type: '',
        sum: ''
      },
      commissionInfo: {
        id: 0,
        type: '',
        sum: '',
        remark: ''
      },
      vipMember: {
        id: 0,
        grade_id: '',
        remark: ''
      },
      parentInfo: {
        id: 0,
        parent_id: '',
        remark: '',
        member: false
      },
      info: false,
      showDialog: false,
      showPDialog: false,
      showJfDialog: false,
      showVipDialog: false,
      showCommissionDialog: false,
      showMemberDialog: false,
      source_domain: this.config.SOURCE_DOMAIN,
      search: {
        current_page: 1,
        total: 0,
        limit: 10,
        user_type: '',
        grade_id: '',
        keywords: ''
      },
      tableData: []
    };
  },
  created() {
    this.getGradeList();
    this.getList();
  },
  mounted() {
  },
  computed: {
    commission() {
      return commission
    }
  },
  methods: {
    getGradeList() {
      this.$api.member.memberGradeIndex({page_size: 100},res=>{
        if(res.errcode==0) {
          this.gradeList = res.data.data
        }
      })
    },
    changeStatus(id,status) {
      let params = {
        id: id,
        status: status
      }
      this.$api.member.memberShenhe(params,res=>{
        if(res.errcode==0) {
          this.success(res.errmsg)
          this.getList()
        } else {
          this.fail(res.errmsg)
        }
      })
    },
    showBox(row) {
      this.moneyInfo.id = row.id
      this.moneyInfo.type = ''
      this.moneyInfo.sum = ''
      this.showDialog = true
    },
    showJfBox(row) {
      this.jfInfo.id = row.id
      this.jfInfo.type = ''
      this.jfInfo.sum = ''
      this.jfInfo.remark = ''
      this.showJfDialog = true
    },
    showCommissionBox(row) {
      this.commissionInfo.id = row.id
      this.commissionInfo.type = ''
      this.commissionInfo.sum = ''
      this.commissionInfo.remark = ''
      this.showCommissionDialog = true
    },
    showPBox(item) {
      this.parentInfo.id = item.id
      this.parentInfo.member = false
      this.parentInfo.remark = ''
      this.showPDialog = true
    },
    showVipBox(item) {
      this.vipMember.id = item.id
      this.vipMember.time = ''
      this.vipMember.remark = ''
      this.showVipDialog = true
    },
    setGradeOk() {
      if(this.vipMember.remark == '') {
        this.fail('请填写备注')
        return false
      }
      this.showLoading()
      this.$api.member.memberSetGrade(this.vipMember,res=>{
        this.hideLoading()
        if(res.errcode==0) {
          this.success(res.errmsg)
          this.getList()
          this.showVipDialog = false
        } else {
          this.fail(res.errmsg)
        }
      })
    },
    chooseMember(item) {
      this.parentInfo.member = item
      this.showMemberDialog = false
    },
    changeParentOk() {
      if(!this.parentInfo.member) {
        this.fail('请选择上级会员')
        return false
      }
      if(this.parentInfo.remark == '') {
        this.fail('请填写备注')
        return false
      }
      let params = {
        id: this.parentInfo.id,
        parent_id: this.parentInfo.member.id,
        remark: this.parentInfo.remark
      }
      this.showLoading()
      this.$api.member.memberSetParent(params,res=>{
        this.hideLoading()
        if(res.errcode==0) {
          this.success(res.errmsg)
          this.showPDialog = false
          this.getList()
        } else {
          this.fail(res.errmsg)
        }
      })
    },
    getList() {
      var _this = this
      _this.showLoading()
      var param = {
        page: _this.search.current_page,
        page_size: _this.search.limit,
        keywords: _this.search.keywords,
        grade_id: _this.search.grade_id,
        user_type: _this.search.user_type,
      }
      this.$api.member.memberIndex(param, function (res) {
        _this.hideLoading()
        if (res.errcode == 0) {
          _this.tableData = res.data.data
          _this.search.current_page = res.data.current_page
          _this.search.total = res.data.total
        } else {
          _this.fail(res.errmsg)
        }
      })
    },
    saveMoney() {
      if(this.moneyInfo.type == '') {
        this.fail('请选择类型')
        return false
      }
      if(this.moneyInfo.sum == '') {
        this.fail('请填写金额')
        return false
      }
      this.$api.member.memberBalanceUpda(this.moneyInfo, res => {
        if(res.errcode==0) {
          this.success(res.errmsg)
          this.getList()
        } else {
          this.fail(res.errmsg)
        }
      })
      this.showDialog = false
    },
    saveIntegral() {
      if(this.jfInfo.type == '') {
        this.fail('请选择类型')
        return false
      }
      if(this.jfInfo.sum == '') {
        this.fail('请填写积分')
        return false
      }
      if(this.jfInfo.remark.trim() == '') {
        this.fail('请填写备注')
        return false
      }
      this.showLoading()
      this.$api.member.memberIntegralUpda(this.jfInfo, res => {
        this.hideLoading()
        if(res.errcode==0) {
          this.showJfDialog = false
          this.success(res.errmsg)
          this.getList()
        } else {
          this.fail(res.errmsg)
        }
      })
      this.showDialog = false
    },
    saveCommission() {
      if(this.commissionInfo.type == '') {
        this.fail('请选择类型')
        return false
      }
      if(this.commissionInfo.sum == '') {
        this.fail('请填写金额')
        return false
      }
      this.$api.member.memberCommissionUpda(this.commissionInfo, res => {
        if(res.errcode==0) {
          this.showCommissionDialog = false
          this.success(res.errmsg)
          this.getList()
        } else {
          this.fail(res.errmsg)
        }
      })
      this.showCommissionDialog = false
    },
    lookIntegralList(id) {
      window.open('/member/integral?member_id='+id)
    },
    lookBalanceList(id) {
      window.open('/member/balance?member_id='+id)
    },
    lookCommissionList(id) {
      window.open('/member/commission?member_id='+id)
    },
    handleSearch() {
      this.search.current_page = 1
      this.getList()
    },
    handleSelectionChange(rows) {
    },
    handleCurrentChange(val) {
      this.search.current_page = val
      this.getList()
    },
    handleSizeChange(val) {
      this.search.current_page = 1
      this.search.limit = val
      this.getList()
    }
  }
};
</script>
<style scoped>
</style>
